import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./Topbar";
import { ThemeProvider } from "@/components/theme-provider";
import { useToast } from "@/hooks/use-toast";
import PasswordChangeRequiredGuard from "@/components/auth/PasswordChangeRequiredGuard";

interface DashboardLayoutProps {
  onLogout: () => void;
}

const DashboardLayout = ({ onLogout }: DashboardLayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { toast } = useToast();

  // Remover: Conexão SSE global para toda a sessão
  // Remover: const { isConnected, error } = useSimpleSSE({
  // Remover:   enabled: true,
  // Remover:   url: buildSSEUrl(SSE_CONFIG.ENDPOINTS.MESSAGE_STREAM),
  // Remover: });

  // Remover: // Log apenas erros em produção
  // Remover: React.useEffect(() => {
  // Remover:   if (error) {
  // Remover:     console.error('❌ Erro SSE:', error);
  // Remover:   }
  // Remover: }, [error]);

  const handleLogout = () => {
    toast({
      title: "Logout realizado",
      description: "Você foi desconectado com sucesso",
    });
    onLogout();
  };

  return (
    <ThemeProvider defaultTheme="light" storageKey="dashboard-theme">
      <div className="h-screen flex flex-col bg-background">
        {/* TopBar */}
        <TopBar onLogout={handleLogout} />

        {/* Main Content Area */}
        <div className="flex flex-1 overflow-hidden">
          <Sidebar
            isCollapsed={sidebarCollapsed}
            onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
            onLogout={handleLogout}
          />

          <main className="flex-1 overflow-auto">
            <div className="p-6">
              <PasswordChangeRequiredGuard>
                <Outlet />
              </PasswordChangeRequiredGuard>
            </div>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default DashboardLayout;
